import { SlotGameType1_21 } from '../SlotGameType1_21';

export class IcyManiaDeluxClassic21 extends SlotGameType1_21
{
}
